import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const getCustomerDetails = ({ id }) => {
  return axios.get(`/customer/details/${id}`);
};

export const useCustomerDetails = ({ id, config }) => {
  return useQuery({
    ...config,
    queryKey: ['userDetail', id],
    queryFn: () => getCustomerDetails({ id }),
  });
};
